export const CAMBIOS = ["Automático", "Manual", "Automatizado", "CVT"];

export const COMBUSTIVEIS = ["Flex", "Gasolina", "Etanol", "Diesel", "Híbrido", "Elétrico", "GNV"];

export const CORES = ["Branco", "Preto", "Prata", "Cinza", "Vermelho", "Azul", "Verde", "Amarelo", "Marrom", "Bege", "Dourado", "Vinho", "Laranja", "Outra"];

export const ESTADOS = ["AC","AL","AP","AM","BA","CE","DF","ES","GO","MA","MT","MS","MG","PA","PB","PR","PE","PI","RJ","RN","RS","RO","RR","SC","SP","SE","TO"];

export const STATIC_BRANDS = ["Chevrolet","Volkswagen","Fiat","Ford","Toyota","Honda","Hyundai","Renault","Jeep","Nissan","Peugeot","Citroën","BMW","Mercedes-Benz","Audi","Mitsubishi","Kia","Volvo","Land Rover","Porsche"];

export const CONDICOES = [
  "Único dono", "IPVA pago", "Licenciado", "Todas as revisões em concessionária",
  "Garantia de fábrica", "Não aceita troca", "Aceita troca", "Veículo financiado",
  "Veículo de colecionador", "Adaptado para PCD",
];

export const OPCIONAIS = [
  "Ar-condicionado", "Direção hidráulica", "Direção elétrica", "Vidros elétricos",
  "Travas elétricas", "Airbag", "Freio ABS", "Banco em couro", "Teto solar",
  "Central multimídia", "Câmera de ré", "Sensor de estacionamento", "Piloto automático",
  "Computador de bordo", "Rodas de liga leve", "Faróis de LED", "Controle de tração",
  "Start/Stop", "Bancos com ajuste elétrico", "Volante multifuncional",
  "Desembaçador traseiro", "Alarme", "Chave presencial", "Tração 4x4",
];

export const parseBRL = (s) => {
  if (typeof s === "number") return s;
  if (!s) return null;
  const n = String(s).replace(/[^\d,]/g, "").replace(",", ".");
  const v = parseFloat(n);
  return isNaN(v) ? null : v;
};

export const formatBRL = (v) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 0 }).format(v || 0);
